/* A later service of a visit going up before an earlier one booked with the
 * same technician — see js/rules/visit-order.js.
 *
 * Asked rather than decided (Kevin, 2026-10-19). One technician usually does a
 * visit's services in the book's order, so the earlier one is offered first;
 * the client may have asked to swap them, so the one that was picked is there
 * too.
 */
import * as Vue from 'vue';
import { store } from '../store.js';

export const OrderAsk = {
  name: 'OrderAsk',
  setup: function () {
    var q = Vue.computed(function () { return store.ui.orderAsk; });
    var name = Vue.computed(function () {
      var s = q.value && store.staffOf(q.value.staffId);
      return (s && s.name) || 'That technician';
    });
    // Whole sentences rather than text stitched around {{ }}: the compiler eats
    // the whitespace either side of an interpolation and the seams show.
    var headline = Vue.computed(function () {
      if (!q.value) return '';
      return q.value.appt.clientName + '’s ' + q.value.earlier.name + ' comes first';
    });
    var body = Vue.computed(function () {
      if (!q.value) return '';
      return 'The book has ' + q.value.earlier.name + ' at ' +
        store.formatClock(q.value.earlier.startsAt) + ' and ' + q.value.later.name + ' at ' +
        store.formatClock(q.value.later.startsAt) + ', both with ' + name.value +
        ', and the ' + q.value.earlier.name + ' is not on the board yet.';
    });
    return {
      q: q, name: name, headline: headline, body: body,
      answer: store.answerOrderAsk, close: store.closeOrderAsk
    };
  },
  template: [
    '<div v-if="q" class="modal-scrim" @click.self="close">',
    '  <div class="sheet" role="alertdialog" aria-modal="true">',
    '    <div class="sheet__head sheet__head--warn">',
    '      <span class="sheet__letter sheet__letter--warn">1</span>',
    '      <div>',
    '        <h3>{{ headline }}</h3>',
    '        <p>{{ body }}</p>',
    '      </div>',
    '    </div>',
    '    <div class="sheet__actions">',
    '      <button type="button" class="btn btn--primary btn--lg" @click="answer(\'earlier\')">',
    '        Start the {{ q.earlier.name }}</button>',
    '      <button type="button" class="btn btn--ghost" @click="answer(\'later\')">',
    '        Start the {{ q.later.name }} anyway</button>',
    '      <button type="button" class="btn btn--quiet" @click="close">Cancel</button>',
    '    </div>',
    '  </div>',
    '</div>'
  ].join('\n')
};
